import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgMoney from '@components/ringil3/icons/Money.tsx';
import { SumPriceExpeditionPreviewOutDTO } from '@api/ringil-api.v2.tsx';
import ExtraCostsPriceTag from '@components/RingilComponents/tags/priceTag/ExtraCostsPriceTag.tsx';

interface ComponentProps {
  sumPrice?: SumPriceExpeditionPreviewOutDTO;
}

const ExtraCostsTag: React.FC<ComponentProps> = ({ sumPrice }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      {isNotNullOrUndefined(sumPrice.extraCostSumPrice) && isNotNullOrUndefined(sumPrice.extraCostSumCurrency) && (
        <ButtonTag
          label={`${tr('ExtraCosts.extraCostSumPrice', 'Celkové vícenáklady')}`}
          value={
            <ExtraCostsPriceTag
              priceDto={sumPrice.extraCostsPriceDTO}
              priceInternalDto={sumPrice.extraCostsInternalPriceDTO}
              badgeType={'none'}
            />
          }
          icon={<SvgMoney />}
          readonly={true}
        />
      )}
    </>
  );
};

export default ExtraCostsTag;
